import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, FormGroup } from 'reactstrap';
import { REQUIRED } from 'configs/constants';
import { getText } from 'helpers/app/getText';

const LinkQuickshop = (props) => {
  const { t, onLinkQuickshop } = props;

  const [linkingCode, setLinkingCode] = useState('');
  const [errors, setErrors] = useState({
    linkingCode: '',
  });

  const linkQuickshop = () => {
    if (linkingCode.length === 0) {
      setErrors({
        linkingCode: REQUIRED('Code', getText('notifications:FIELD_VALIDATION_REQUIRED_MSG')),
      });
    } else if ((linkingCode.length > 0 && linkQuickshop.length > 15) || !/^[A-Za-z0-9]+$/.test(linkingCode)) {
      setErrors({
        linkingCode: getText('notifications:INVALID_LINKING_CODE'),
      });
    } else {
      onLinkQuickshop(linkingCode);
      setErrors({
        linkingCode: '',
      });
    }
  };

  return (
    <div className="container standard-container">
      <div className="row">
        <div className="col text-center">
          <img src="img/logo.jpeg" className="link-quickshop-logo" />
        </div>
      </div>
      <br />
      <div className="row text-center link-quickshop-content">
        <div className="text-left">{getText('main:LINK_QUICKSHOP_TEXT')}</div>
        <div className="text-center link-quickshop-form">
          <FormGroup>
            <label>{getText('main:LINKING_CODE')}:</label>
            <Input type="text" name="text" className={`${errors.linkingCode && `input-normal-error-msg`}`} value={linkingCode || ''} onChange={(ev) => setLinkingCode(ev.target.value)} />
            <p className={`error-msg ${!errors.linkingCode && 'hidden'}`}>{errors.linkingCode}</p>
          </FormGroup>
          <button type="button" onClick={() => linkQuickshop()} className="btn link-quickshop-btn btn-success ml-2">
            {getText('main:LINK')}
          </button>
        </div>
      </div>
    </div>
  );
};

LinkQuickshop.displayName = 'LinkQuickshop';

LinkQuickshop.propTypes = {};

export default LinkQuickshop;
